import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { 
    selected: { type: Number, default: 0 },
    storageKey: String 
  }
  
  connect() {
    if (this.hasStorageKeyValue) {
      const saved = localStorage.getItem(this.storageKeyValue)
      if (saved !== null) {
        this.selectedValue = parseInt(saved, 10)
      }
    }
    this.showPanel(this.selectedValue)
  }
  
  select(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    if (index === -1) return
    
    this.selectedValue = index
    this.showPanel(index)
    
    if (this.hasStorageKeyValue) {
      localStorage.setItem(this.storageKeyValue, index.toString())
    }
  }
  
  showPanel(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.dataset.selected = i === index ? "true" : "false"
      tab.setAttribute("aria-selected", (i === index).toString())
    })
    
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
